/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const NestedHistory = zod.strictObject({
    level: zod.string(),
    created_at: zod.iso.datetime({ offset: true }),
    updated_at: zod.iso.datetime({ offset: true }),
    status: zod
        .enum([
            'ACCEPTED',
            'REJECTED',
            'SKIPPED',
            'UNKNOWN',
            'SUBMISSION',
            'NEW_VERSION',
        ])
        .optional()
        .describe(
            '\* `ACCEPTED` - Accepted\n\* `REJECTED` - Rejected\n\* `SKIPPED` - Skipped\n\* `UNKNOWN` - Unknown\n\* `SUBMISSION` - Submission\n\* `NEW_VERSION` - New version',
        ),
    comment: zod.string().optional(),
    updated_by: zod.string().nullable(),
    created_by: zod.string(),
});

export type NestedHistory = zod.input<typeof NestedHistory>;
export type NestedHistoryOutput = zod.output<typeof NestedHistory>;
